import React from 'react';
import { Badge } from './ui/badge';
import { skills } from '../mock';

const Skills = () => {
  const categories = [...new Set(skills.map((skill) => skill.category))];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Skills & Technologies
          </h2>
          <div className="w-20 h-1 bg-cyan-600 mx-auto"></div>
        </div>

        <div className="space-y-12">
          {categories.map((category) => (
            <div key={category}>
              <h3 className="text-2xl font-semibold text-gray-900 mb-6">
                {category}
              </h3>
              <div className="flex flex-wrap gap-3">
                {skills
                  .filter((skill) => skill.category === category)
                  .map((skill, index) => (
                    <Badge
                      key={index}
                      variant="outline"
                      className="px-6 py-3 text-base border-2 border-gray-300 hover:border-cyan-600 hover:bg-cyan-50 transition-all cursor-default"
                    >
                      {skill.name}
                    </Badge>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;